var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.248 25.2502C14.8239 25.2502 16.3843 24.9399 17.8402 24.3368C19.2962 23.7337 20.619 22.8498 21.7333 21.7355C22.8476 20.6212 23.7315 19.2984 24.3346 17.8424C24.9377 16.3865 25.248 14.8261 25.248 13.2502C25.248 11.6744 24.9377 10.1139 24.3346 8.65804C23.7315 7.20214 22.8476 5.87927 21.7333 4.76496C20.619 3.65066 19.2962 2.76675 17.8402 2.16369C16.3843 1.56063 14.8239 1.25024 13.248 1.25024C10.0654 1.25024 7.0132 2.51453 4.76276 4.76496C2.51233 7.0154 1.24805 10.0676 1.24805 13.2502C1.24805 16.4328 2.51233 19.4851 4.76276 21.7355C7.0132 23.986 10.0654 25.2502 13.248 25.2502Z",
    fill: "#E1F4D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 5.75C1.6875 7.8375 0.75 10.4375 0.75 13.25C0.75 20.15 6.35 25.75 13.25 25.75C20.15 25.75 25.75 20.15 25.75 13.25C25.75 6.35 20.15 0.75 13.25 0.75C11.4625 0.75 9.75 1.125 8.2125 1.8125",
    stroke: "#1C452B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29043 13.4485H6.70312C6.70312 16.8897 9.61027 19.7977 13.0523 19.7977C16.4944 19.7977 19.4015 16.8897 19.4015 13.4485C19.4015 10.0072 16.4944 7.09926 13.0523 7.09926V5.51196L9.89757 7.89292L13.0523 10.2739V8.68657C15.6333 8.68657 17.8142 10.8675 17.8142 13.4485C17.8142 16.0294 15.6333 18.2104 13.0523 18.2104C10.4714 18.2104 8.29043 16.0294 8.29043 13.4485Z",
    fill: "#1C452B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReRequestIcon);
export default __webpack_public_path__ + "static/media/reRequestIcon.aa162f254603bfb95035ce554b683a76.svg";
export { ForwardRef as ReactComponent };